import React from "react";

export const LogoTile = ({ size = 38 }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" className="shrink-0 drop-shadow-sm">
        <rect width="48" height="48" rx="12" fill="#1FA5C9" />
        <path d="M34.5 8.5c3.2 1.6 4.8 4.8 4.8 8.6-3.2-1.6-4.8-4.8-4.8-8.6z" fill="#DDE5DB" />
        <path d="M28 6.5c.6 3.4-.4 6.6-2.6 8.8-1.8-3.2-1.2-6.4 2.6-8.8z" fill="#9AB098" />
        <path d="M11 7l1.4 3.3 3.3 1.4-3.3 1.4L11 16.4l-1.4-3.3-3.3-1.4 3.3-1.4z" fill="#ffffff" />
        <path d="M13 25c2.8 6.2 6.6 9.2 11 9.2s8.2-3 11-9.2" fill="none" stroke="#ffffff" strokeWidth="3.4" strokeLinecap="round" />
        <path d="M16.5 25h15" stroke="#ffffff" strokeWidth="3.4" strokeLinecap="round" opacity="0.85" />
    </svg>
);

export const Wordmark = ({ light = false }) => (
    <span className={`font-serif font-bold text-lg tracking-tight ${light ? "text-[#FDFCF8]" : "text-[#1A1D1A]"}`}>
        Smart<span className="text-[#1FA5C9]">Breath</span>Check
    </span>
);

export const Logo = ({ light = false }) => (
    <span className="inline-flex items-center gap-2.5">
        <LogoTile />
        <Wordmark light={light} />
    </span>
);
